module.exports = __webpack_public_path__ + "media/my_images/top/main_kv-0e2e3984699891d433745bd17bde54e8.jpg";